import React from 'react';
import propTypes from 'prop-types';
import { Routes, Route } from 'react-router-dom';
import { DocumentsListPage } from './DocumentsListPage';

export function DocumentsPage({ location, isExpanded }) {
  return (
    <Routes location={location}>
      <Route
        path="/"
        element={<DocumentsListPage isExpanded={isExpanded} />}
      />
    </Routes>
  );
}

DocumentsPage.propTypes = {
  location: propTypes.object.isRequired,
  isExpanded: propTypes.bool.isRequired,
};
